/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from "@emotion/react";
import SearchIcon from "@material-ui/icons/Search";

import { KEYWORD_MAX_COUNT } from "../../constants/keywordMaxCount";
import { BlackButton } from "../BlackButton";
import { DetailedSearchModalButton } from "./components/DetailedSearchModalButton";
import {
  detailedSearchModalButtonWrapperStyle,
  inputStyle,
  searchButtonLabelStyle,
  searchButtonStyle,
  searchFormStyle,
  searchInputContainerStyle,
  searchRowStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { Props } from "./props";

export const SearchForm: React.FC<Props> = (props) => {
  const { keyword, onChangeKeyword, setModalOpen } = props;
  const { canSearch, handleSearch, inputRef, keywordInputTitle, t } =
    useThis(props);

  return (
    <form css={searchFormStyle} onSubmit={handleSearch}>
      <div css={searchRowStyle}>
        <div css={searchInputContainerStyle}>
          <input
            ref={inputRef}
            aria-label={t("search.searchLabel")}
            css={inputStyle}
            maxLength={KEYWORD_MAX_COUNT}
            onChange={onChangeKeyword}
            placeholder={t("search.searchPlaceholder")}
            title={keywordInputTitle}
            type="text"
            value={keyword}
          />
        </div>
        <div>
          <BlackButton
            aria-disabled={!canSearch}
            disabled={!canSearch}
            css={searchButtonStyle}
            type="submit"
          >
            <SearchIcon />
            <span css={searchButtonLabelStyle}>{t("search.doSearch")}</span>
          </BlackButton>
        </div>
        <div css={detailedSearchModalButtonWrapperStyle}>
          <DetailedSearchModalButton setModalOpen={setModalOpen} />
        </div>
      </div>
    </form>
  );
};
